import Logger from '@/lib/logger';
import { NEXT_PUBLIC_OPENAI_ADS_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('OpenAIAds', 'DEBUG');

// Single source of truth for whether debug output is emitted. Exported so call sites can guard the construction of debug payload objects (the logger methods are no-ops when disabled, but the argument objects are still allocated).
export const isOpenAIAdsLoggingEnabled = NEXT_PUBLIC_OPENAI_ADS_LOGGING_ENABLED;

if (isOpenAIAdsLoggingEnabled) {
  logger.enable();
}

export default logger;
